import { styled, Box } from '@ltvco/refresh-lib/theme';

export const BenefitRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(2),
}));
